<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.svg" />
    </vue-element-loading>
    <b-row>
      <b-col cols="12" lg="12">
        <b-card no-header>
          <template slot="header">Add New Item </template>
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="12">
              <!-- Item Details -->
              <b-row>
                <b-col class="py-3 text-center">
                  <span
                    style="font-size: 20px; font-weight: 500; color: #a7a7a7"
                  >
                    Item Details
                  </span>
                </b-col>
              </b-row>

              <b-row class="justify-content-md-center">
                <b-col cols="12" md="4" style="display: none">
                  <div :class="{ error: validation.hasError('Shop') }">
                    <b-form-group>
                      <label>Shop</label>
                      <b-form-input
                        v-model="Shop"
                        type="text"
                        id="Shop"
                        placeholder="Shop"
                      />
                      <template
                        slot="description"
                        v-if="validation.firstError('Shop')"
                      >
                        <span style="color: red">{{
                          validation.firstError("Shop")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div :class="{ error: validation.hasError('Name') }">
                    <b-form-group>
                      <label>Item Name</label>
                      <b-form-input
                        v-model="Name"
                        type="text"
                        id="Name"
                        placeholder="Name"
                      />
                      <template
                        slot="description"
                        v-if="validation.firstError('Name')"
                      >
                        <span style="color: red">{{
                          validation.firstError("Name")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div :class="{ error: validation.hasError('itemcode') }">
                    <b-form-group>
                      <label>Item Code</label>
                      <b-form-input
                        v-model="itemcode"
                        type="text"
                        id="itemcode"
                        placeholder="Item Code"
                      />
                      <template
                        slot="description"
                        v-if="validation.firstError('itemcode')"
                      >
                        <span style="color: red">{{
                          validation.firstError("itemcode")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div :class="{ error: validation.hasError('CategoryID') }">
                    <b-form-group>
                      <label>Category</label>
                      <b-form-select
                        v-model="CategoryID"
                        id="CategoryID"
                        :options="categories"
                        text-field="Name"
                        value-field="ID"
                      ></b-form-select>
                      <template
                        slot="description"
                        v-if="validation.firstError('CategoryID')"
                      >
                        <span style="color: red">{{
                          validation.firstError("CategoryID")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <!-- <b-col cols="12" md="4">
                  <div
                    :class="{
                      error: validation.hasError('AvailableQuantity'),
                    }"
                  >
                    <b-form-group>
                      <label>Avalilable Quantity</label>
                      <b-form-input
                        v-model="AvailableQuantity"
                        type="text"
                        id="AvailableQuantity"
                        placeholder="Avalilable Quantity"
                      />
                      <template
                        slot="description"
                        v-if="validation.firstError('AvailableQuantity')"
                      >
                        <span style="color: red">{{
                          validation.firstError("AvailableQuantity")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col> -->
                <!-- <b-col cols="12" md="4">
                  <div :class="{ error: validation.hasError('ReorderValue') }">
                    <b-form-group>
                      <label>Reorder Value</label>
                      <b-form-input
                        v-model="ReorderValue"
                        type="text"
                        id="ReorderValue"
                        placeholder="Reorder Value"
                      />
                      <template
                        slot="description"
                        v-if="validation.firstError('ReorderValue')"
                      >
                        <span style="color: red">{{
                          validation.firstError("ReorderValue")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col> -->
                <b-col cols="12" md="4">
                  <div :class="{ error: validation.hasError('Price') }">
                    <b-form-group>
                      <label>MRP</label>
                      <b-form-input
                        v-model="Price"
                        type="text"
                        id="Price"
                        placeholder="Price"
                      />
                      <template
                        slot="description"
                        v-if="validation.firstError('Price')"
                      >
                        <span style="color: red">{{
                          validation.firstError("Price")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div :class="{ error: validation.hasError('SellingPrice') }">
                    <b-form-group>
                      <label>Selling Price</label>
                      <b-form-input
                        v-model="SellingPrice"
                        type="text"
                        id="SellingPrice"
                        placeholder="Selling Price"
                      />
                      <template
                        slot="description"
                        v-if="validation.firstError('SellingPrice')"
                      >
                        <span style="color: red">{{
                          validation.firstError("SellingPrice")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div :class="{ error: validation.hasError('Enabled') }">
                    <b-form-group>
                      <label>Enabled</label>
                      <b-form-select
                        v-model="Enabled"
                        id="Enabled"
                        :options="[true, false]"
                        text-field="Name"
                        value-field="ID"
                      ></b-form-select>
                      <template
                        slot="description"
                        v-if="validation.firstError('Enabled')"
                      >
                        <span style="color: red">{{
                          validation.firstError("Enabled")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <label>Image</label>
                  <b-form-file
                    v-model="Image"
                    @change="uploadPic"
                  ></b-form-file>
                </b-col>

                <b-col cols="12" md="12">
                  <div :class="{ error: validation.hasError('Description') }">
                    <b-form-group>
                      <label>Description</label>
                      <b-form-textarea
                        v-model="Description"
                        type="text"
                        id="Description"
                        placeholder="Description"
                      ></b-form-textarea>
                      <template
                        slot="description"
                        v-if="validation.firstError('Description')"
                      >
                        <span style="color: red">{{
                          validation.firstError("Description")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>

                <b-col
                  cols="12"
                  md="12"
                  class="py-4 text-center"
                  v-if="!productImage"
                >
                  <b-row>
                    <b-col
                      cols="12"
                      md="3"
                      class="pt-4"
                      v-for="(item, i) in inventory.inv.images"
                      :key="i"
                    >
                      <b-img
                        :src="baseURL + '/r/' + item"
                        width="250px"
                      ></b-img>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12" md="6" class="py-4 text-center">
                  <b-img
                    v-if="productImage"
                    :src="productImage"
                    width="250px"
                  ></b-img>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="justify-content-center">
            <div class="px-2">
              <b-button
                variant="outline-primary"
                size="sm"
                @click.prevent="validateInput"
              >
                Update Item
              </b-button>
            </div>
          </b-row>

          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ServerError: false,
      appLoading: false,
      msg: null,
      categories: [],
      Shop: localStorage.getItem("shopid"),
      Name: null,
      itemcode: null,
      Description: null,
      CategoryID: null,
      AvailableQuantity: null,
      ReorderValue: null,
      Price: null,
      Enabled: true,
      Image: null,
      itemID: null,
      InvID: null,
      productImage: null,
      SellingPrice: null,
      inventory: {
        inv: {},
      },
    };
  },
  beforeMount() {
    this.getCategory();
    this.getData();
  },
  validators: {
    Shop(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(24)
        .maxLength(32);
    },
    Name(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(1)
        .maxLength(120);
    },
    itemcode(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(1)
        .maxLength(512);
    },
    Description(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(50)
        .maxLength(512);
    },
    CategoryID(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(24)
        .maxLength(32);
    },
    AvailableQuantity(value) {
      return this.Validator.value(value)
        .integer("Provide a valid number")
        .required("Required Field");
    },
    ReorderValue(value) {
      return this.Validator.value(value).float().required("Required Field");
    },
    Price(value) {
      return this.Validator.value(value).float().required("Required Field");
    },
    SellingPrice(value) {
      return this.Validator.value(value).float().required("Required Field");
    },
    Enabled(value) {
      return this.Validator.value(value).required("Required Field");
    },
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        url: "/inv/item",
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        data: {
          shop: localStorage.getItem("shopid"),
          item: this.$route.params.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.inventory = response.data.data;

          this.Name = this.inventory.details.name;
          this.itemcode = this.inventory.details.itemcode;

          this.Description = this.inventory.details.description;
          this.CategoryID = this.inventory.details.category_id;
          this.AvailableQuantity = this.inventory.inv.available_quantity;
          this.ReorderValue = this.inventory.inv.reorder_value;
          this.Price = this.inventory.inv.selling_price;
          this.SellingPrice = this.inventory.inv.price;
          this.itemID = this.inventory.inv.item;
          this.Enabled = this.inventory.inv.enabled;
          this.InvID = this.inventory.inv.id;
          if (this.inventory.inv.images == null) this.inventory.inv.images = [];
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    getCategory() {
      this.appLoading = true;
      axios({
        url: "/category",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.categories = response.data.data;
          // if (this.categories.length > 0) {
          //   this.CategoryID = this.categories[0].ID;
          // }
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    validateInput() {
      this.msg = null;
      this.$validate().then((success) => {
        if (success) {
          this.editItem();
        } else {
          this.msg = "Please validate input fields";
          return;
        }
      });
    },
    uploadPic(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files[0].size > 5242880) {
        this.$notify({
          group: "appNotification",
          title: "File Should be less than 5MB",
          text: "",
          type: "error",
        });
        return;
      }
      this.Image = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.productImage = e.target.result;
      };
      reader.readAsDataURL(files[0]);
    },
    editItem() {
      this.appLoading = true;
      var item = {};
      item["id"] = this.$route.params.id;
      item["id"] = this.itemID;
      item["shop"] = this.Shop;
      item["name"] = this.Name;
      item["itemcode"] = this.itemcode;
      item["description"] = this.Description;
      item["category_id"] = this.CategoryID;
      item["available_quantity"] = Number(this.AvailableQuantity);
      item["reorder_value"] = Number(this.ReorderValue);
      item["price"] = Number(this.SellingPrice);
      item["enabled"] = Boolean(this.Enabled);
      item["item"] = this.itemID;
      item["inid"] = this.InvID;
      item["selling_price"] = Number(this.Price);
      axios({
        method: "PUT",
        url: "/item",
        data: item,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            if (this.Image) {
              this.addPhoto(response.data.body.id);
              // this.addPhoto(this.itemID);
              this.editInv(item);
            } else {
              //calling inventory edit route
              this.editInv(item);
            }
          } else {
            this.msg = response.data.msg;
            var vm = this;
            this.$notify({
              group: "appNotification",
              title: vm.msg,
              text: "",
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    editInv(item) {
      axios({
        method: "PUT",
        url: "/inventory",
        data: item,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$notify({
              group: "appNotification",
              title: "Product Updated Successfully",
              text: "",
              type: "success",
            });
            this.$router.go(-1);
          } else {
            this.msg = response.data.msg;
            var vm = this;
            this.$notify({
              group: "appNotification",
              title: vm.msg,
              text: "",
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    addPhoto(id) {
      this.appLoading = true;
      let formData = new FormData();
      formData.append("shop", this.Shop);
      formData.append("id", this.InvID);
      formData.append("image", this.Image);

      axios({
        method: "POST",
        url: "/inventory/item/add/image",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$notify({
              group: "appNotification",
              title: "Product Updated Successfully",
              text: "",
              type: "success",
            });
            this.$router.go(-1);
          } else {
            this.msg = response.data.msg;
            var vm = this;
            this.$notify({
              group: "appNotification",
              title: vm.msg,
              text: "",
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
  },
};
</script>